import * as React from "react";
import MuiDialogActions, {
    DialogActionsProps as MuiDialogActionsProps,
    DialogActionsClassKey as MuiDialogActionsClassKey
} from "@material-ui/core/DialogActions";

export type DialogActionsClassKey = MuiDialogActionsClassKey;

export interface DialogActionsProps extends MuiDialogActionsProps { }

class DialogActions extends React.PureComponent<DialogActionsProps> {
    render() {
        const { ...props } = this.props;
        return <MuiDialogActions {...props}>
            {this.props.children}
        </MuiDialogActions>;
    }
}

export default DialogActions;